<iframe
  id="ifTokenize_{{ formName }}"
  #paymentFrame
  style="border: none; width: 100%;"
  scrolling="no"
  [src]="iframeSrc"
></iframe>